export const newsList = [
  {
    id: "new-anime-season-preview-2026",
    title: "2026 秋季新番前瞻：本季最值得期待的 12 部动画",
    summary:
      "秋季档向来是全年竞争最激烈的档期。本期我们梳理了 12 部预约量与讨论度双高的作品，从原创剧场级制作到人气漫画改编，一次性看清新番格局。",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20anime%20key%20visual%20of%20a%20young%20hero%20standing%20on%20a%20neon%20lit%20rooftop%20at%20dusk%2C%20warm%20orange%20clouds%2C%20detailed%20cel%20shaded%20illustration%2C%20cinematic%20composition%2C%20cohesive%20orange%20and%20navy%20palette%2C%20clean%20atmospheric%20background%20art&width=800&height=450&seq=news-cover-01&orientation=landscape",
    date: "2026-10-12",
    category: "新番前瞻",
    author: "编辑部 · 青橙",
    source: "漫蛙2 编辑部",
    tags: ["新番", "秋季档", "前瞻", "动画推荐"],
    content: [
      "随着夏季档进入尾声，各大制作公司陆续公布了秋季新番的播出排期。从目前公开的 PV 与前导情报来看，本季的整体制作规格是近三年最高的一档，多家工作室拿出了压箱底的企划。",
      "在原创作品方面，最受关注的是由资深演出家领衔的科幻题材《星环彼岸》。它用极简的色块与大量留白构建出一种冷峻的未来感，配合岩崎琢风格的电子配乐，PV 上线三天播放量便突破八百万。",
      "改编作品中，人气漫画《夜行列车》的动画化终于落地。制作组表示会保留原作关键的「车站」章节，并邀请原作者全程监修分镜，这在近年改编作品中并不常见。",
      "值得注意的是，本季有超过四成作品采用双季度连播的形式。对观众而言这意味着更完整的故事体验，但也对制作排期提出了更高要求。我们会在开播后持续跟进制作进度，为大家提供及时的更新速递。",
      "最后提醒一句：新番的预约与追番清单已经可以在本站「动画更新」页查看，收藏你感兴趣的作品，开播第一时间就不会错过。"
    ]
  },
  {
    id: "magical-girl-revival-trend",
    title: "魔法少女题材回潮：为什么治愈与成长再次打动观众",
    summary:
      "从今年三部高分魔法少女作品入手，聊聊这个题材如何在视觉升级之外，重新找回关于成长与自我接纳的表达。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20magical%20girl%20running%20through%20a%20glowing%20cherry%20blossom%20street%20at%20night%2C%20warm%20lantern%20lights%2C%20detailed%20cel%20shaded%20art%2C%20cinematic%20wide%20shot%2C%20cohesive%20orange%20and%20deep%20blue%20tones%2C%20clean%20background&width=800&height=450&seq=news-cover-02&orientation=landscape",
    date: "2026-10-09",
    category: "深度解读",
    author: "特约作者 · 南屿",
    source: "漫蛙2 专栏",
    tags: ["魔法少女", "题材解读", "成长", "治愈"],
    content: [
      "过去十年，魔法少女题材经历了从「战斗爽番」到「解构黑深残」的多轮演变。而今年重新回到观众视野的三部作品，不约而同地选择了另一条路——把镜头重新对准少女的内心。",
      "《星屑礼赞》用近乎日常片的节奏铺陈主角的犹豫，变身场景不是为了炫技，而是她第一次承认「我想保护某个人」的瞬间。这种把高光时刻让位给情感转折的处理，让不少成年观众直呼被戳中。",
      "视觉层面，本季作品普遍采用了更低饱和的背景与更高亮的角色配色，形成明确的视觉重心。音乐上则大量使用钢琴与弦乐，减少电子音效的使用频率。",
      "当然，回潮不代表同质化。三部作品在结局处理上差异明显，有人选择温柔的告别，也有人留下开放式的悬念。正是这种多样性，让题材重新变得值得期待。",
      "我们也在社区发起了「你最爱的魔法少女作品」讨论，欢迎到话题里留下你的答案。"
    ]
  },
  {
    id: "animation-fight-scene-craft",
    title: "一镜到底的打斗是怎样炼成的：动画作画流程浅析",
    summary:
      "为什么有些打斗看得人起鸡皮疙瘩？从原画、中割到摄影合成，拆解一段高评价战斗场景背后的完整工序。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20two%20rival%20swordsmen%20facing%20off%20in%20a%20bamboo%20forest%20with%20sunbeams%2C%20dynamic%20action%20pose%2C%20detailed%20cel%20shaded%20key%20visual%2C%20cinematic%20lighting%2C%20warm%20orange%20and%20navy%20color%20scheme%2C%20clean%20background&width=800&height=450&seq=news-cover-03&orientation=landscape",
    date: "2026-10-06",
    category: "科普专栏",
    author: "技术组 · 白描",
    source: "漫蛙2 科普",
    tags: ["作画", "打斗", "幕后", "科普"],
    content: [
      "一段被反复二创的打斗镜头，往往只有十几秒，却可能消耗一支团队数月的时间。理解它的制作流程，能让你在看番时多一层乐趣。",
      "第一步是原画。关键动作的姿态、节奏与构图在这一阶段被确定，一位优秀的原画师会让关键帧本身就具备张力，即便不播放也能看出动作走向。",
      "第二步是中割，也就是补齐关键帧之间的过渡。看似机械，实际上需要理解动作的发力方向，否则画面会「飘」。高难度的长镜头往往由少数顶尖原画师直接包办，以减少风格割裂。",
      "第三步是背景与摄影合成。运镜的冲击力很大程度来自背景的透视变化与镜头模糊，摄影组会叠加光效、残影与色彩偏移来强化速度感。",
      "理解这三层之后，再回看那些名场面，你会发现真正打动人的从来不是单纯的「帧数多」，而是节奏与情绪的精准配合。"
    ]
  },
  {
    id: "mecha-renaissance-2026",
    title: "机甲动画的新方法：从重工业美学到人物驱动叙事",
    summary:
      "机甲番正在减少对参数与设定的依赖，转而用关系与抉择撑起故事。本文梳理这一转向背后的市场与创作逻辑。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20scene%20of%20a%20mecha%20pilot%20standing%20before%20a%20giant%20robot%20in%20a%20futuristic%20city%20at%20sunset%2C%20dramatic%20sky%2C%20detailed%20illustration%2C%20cinematic%20composition%2C%20warm%20orange%20and%20deep%20blue%20palette%2C%20clean%20background%20art&width=800&height=450&seq=news-cover-04&orientation=landscape",
    date: "2026-10-03",
    category: "深度解读",
    author: "特约作者 · 铁翼",
    source: "漫蛙2 专栏",
    tags: ["机甲", "叙事", "科幻", "行业观察"],
    content: [
      "很长一段时间里，机甲动画的卖点是「设定密度」：武器参数、机体代数、势力关系图。但近两年的高口碑作品，开始把叙事重心从机器转移到驾驶舱里的人。",
      "《钢之声》几乎没有出现完整的机体说明卡，取而代之的是主角在训练中反复失败、与搭档磨合的日常。观众记住的不是火力值，而是那句「这次换我掩护你」。",
      "这种转向与新一代观众的观看习惯有关。信息获取变得容易之后，稀缺的反而是有代入感的情感体验。机甲成为承载关系的容器，而非需要被解析的谜题。",
      "当然，重工业美学并未消失。精细的机械作画依旧是一大看点，只是它更多服务于「人机之间的物理联系」这一主题。",
      "如果你也喜欢机甲题材，社区里的「机甲推荐讨论区」正在征集本季私心推荐，欢迎来聊聊。"
    ]
  },
  {
    id: "music-anime-slice-of-life",
    title: "音乐系日常番为何总能治愈人心：声音设计的四个细节",
    summary:
      "从环境音、留白、乐器质感与呼吸声四个角度，聊聊音乐题材日常番如何营造让人放松的观看体验。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cheerful%20girl%20with%20headphones%20in%20a%20cozy%20music%20room%20filled%20with%20warm%20light%2C%20slice%20of%20life%20mood%2C%20detailed%20cel%20shaded%20art%2C%20soft%20cinematic%20lighting%2C%20orange%20and%20navy%20tones%2C%20clean%20background&width=800&height=450&seq=news-cover-05&orientation=landscape",
    date: "2026-09-30",
    category: "科普专栏",
    author: "声音组 · 木子",
    source: "漫蛙2 科普",
    tags: ["音乐", "日常", "治愈", "声音设计"],
    content: [
      "音乐系日常番看似「没什么剧情」，却能让人反复观看。秘密很大程度上藏在声音设计里。",
      "第一是环境音。翻谱声、椅子挪动声、窗外隐约的车流，这些细碎的声音构建出一个可以被信任的生活空间。",
      "第二是留白。好的日常番敢于在对话之间保留沉默，让观众有时间消化情绪，而不是用台词填满每一秒。",
      "第三是乐器质感。制作组往往实录真实乐器，甚至保留演奏中的微小失误，这种「不完美」反而让人感到真实。",
      "第四是呼吸声。角色的吸气与叹息被刻意放大，它比台词更直接地传递情绪。下次重看时，试着闭上眼只听声音，你会有全新的发现。"
    ]
  },
  {
    id: "fantasy-worldbuilding-guide",
    title: "异世界设定怎么才算扎实：从世界规则到角色动机",
    summary:
      "不是设定越复杂越好。本文用三个正面与两个反面案例，讲清楚一个可信的异世界需要具备哪些基本要素。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20fantasy%20adventurer%20overlooking%20a%20floating%20island%20kingdom%20above%20the%20clouds%2C%20epic%20wide%20shot%2C%20detailed%20cel%20shaded%20illustration%2C%20warm%20sunset%20lighting%2C%20orange%20and%20deep%20blue%20palette%2C%20clean%20background&width=800&height=450&seq=news-cover-06&orientation=landscape",
    date: "2026-09-27",
    category: "深度解读",
    author: "特约作者 · 岚",
    source: "漫蛙2 专栏",
    tags: ["异世界", "世界观", "设定", "解读"],
    content: [
      "异世界题材常被吐槽「套路」，但真正的问题往往不是套路本身，而是世界观规则与角色动机之间的脱节。",
      "一个扎实的设定，首先要能回答「代价是什么」。魔法有代价、力量有代价、选择也有代价，代价让冲突变得可信。",
      "其次是规则的稳定性。观众可以接受复杂的规则，但无法接受为了剧情方便而随意更改的规则。前后一致的约束，才是紧张感的来源。",
      "最后是角色动机。主角为什么要战斗、为什么要留下，这些问题的答案必须来自他自身，而不是剧情的需要。",
      "反观一些失败案例，问题通常出在「设定只在需要时才出现」。当世界观沦为装饰，观众自然也难以投入。"
    ]
  }
];